import React, { Component } from "react";
import { Link } from "react-router-dom";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import ITakeOffConvertToOrderDTO from "../../../models/DTO/ITakeOffConvertToOrderDTO";
import ITakeOffOnConvertToOrderDTO from "../../../models/DTO/ITakeOffOnConvertToOrderDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import ICategory from "../../../models/ICategory";
import INotification from "../../../models/INotification";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import OwButton from "../../shared/OwButton/OwButton";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import { Socket } from "socket.io-client";

type Props = {
    cancelFn: (refreshData?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    setActivityIndicator: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    types: ICategory[];
    orderGuid: string;
};

type State = {
    createActive: boolean;
    types: { [key: string]: boolean };
    hasConverted: boolean;
};

class TakeOffConvertToOrderSidebar extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        const types: { [key: string]: boolean } = {};

        for (const type of this.props.types) {
            types[type.name] = true;
        }

        this.state = {
            createActive: false,
            types,
            hasConverted: false,
        };
    }

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.TakeOffOnConvertToOrder, this.onConvertToOrder);
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.TakeOffOnConvertToOrder, this.onConvertToOrder);
    }

    cancel = (refreshData?: boolean) => {
        this.props.cancelFn(refreshData);
    };

    create = () => {
        const types: ICategory[] = [];

        for (const type of Object.keys(this.state.types)) {
            if (this.state.types[type]) {
                for (const availType of this.props.types) {
                    if (availType.name === type) {
                        types.push(availType);
                    }
                }
            }
        }

        const payload: ITakeOffConvertToOrderDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            types,
            orderGuid: this.props.orderGuid,
        };

        this.props.socket.emit(EndpointsEnum.TakeOffConvertToOrder, payload);
    };

    onConvertToOrder = (data: ITakeOffOnConvertToOrderDTO) => {
        const notification: INotification = {
            message: "successfully_converted_to_order_s",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            hasConverted: true,
        });
    };

    toggleOrderForType = (type: ICategory) => {
        const types = this.state.types;

        types[type.name] = !types[type.name];

        this.setState({
            types,
        });
    };

    closeSidebar = () => {
        this.props.cancelFn(false);
    };

    render() {
        return (
            <div className={"TakeOffConvertToOrderSidebar p-2"}>
                <div className={"col-12"}>
                    <div className="text-end">
                        <button
                            className="btn btn-danger btn-sm"
                            onClick={() => {
                                this.cancel();
                            }}>
                            <i className="far fa-times" />
                        </button>
                    </div>
                    <OwTitle className={"mb-2"} leftIconName={"fad fa-retweet-alt"} title={"convert_to_order"} />
                    <hr />
                </div>

                {this.state.hasConverted ? (
                    <div className={"col-12"}>
                        <Link to={"/orders"} onClick={this.closeSidebar}>
                            <OwLabel title={"view_orders"} />
                        </Link>
                    </div>
                ) : (
                    <div className={"col-12"}>
                        {this.props.types.map((type) => {
                            if (type.has_dependents) {
                                return null;
                            } else {
                                return (
                                    <div key={type.guid}>
                                        <OwCheckbox
                                            label={type.name}
                                            skipTranslate={true}
                                            fn={() => {
                                                this.toggleOrderForType(type);
                                            }}
                                            truthyVal={true}
                                            falsyVal={false}
                                            checked={this.state.types[type.name]}
                                        />
                                    </div>
                                );
                            }
                        })}
                    </div>
                )}

                <div>
                    <OwButton title={"create"} fn={this.create} active={this.state.createActive} disableOnActive={true} />
                </div>
            </div>
        );
    }
}

export default TakeOffConvertToOrderSidebar;
